import React, { Component } from "react";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import { PropertiesWithProject } from "@eres/ejari-api/Entity/LeasedProperties";
import Strings from "@my-dld/assets/strings";
import { I8N, LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";

export interface ProjectProps {
	projects: PropertiesWithProject[];
	onProjectSelect: ( project: PropertiesWithProject ) => void;
}

class ProjectListView extends Component<ProjectProps> {
	componentDidMount() {
		this.configDataTable();
	}

	render() {
		const { projects } = this.props;
		return <ListDataView
			isSearchable={ false }
			items={ projects }
			renderListHeader={ () => <RenderHeader/> }
			renderListItem={ ( item: PropertiesWithProject ) => {
				return <RenderListItem
					key={ "prop_with_projects_list_" + item.ProjectId }
					project={ item }/>;
			} }/>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: false,
				lengthChange: false,
				searching: false,
				scrollX: true
			} );
			const onProjectSelect = this.props.onProjectSelect;
			window.$( "#ListView" ).on( "click", "a", function () {
				// @ts-ignore
				let item = JSON.parse( this.getAttribute( "data-item" ) );
				if ( item )
					onProjectSelect( item );
				return false;
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.project_number }</th>
		<th>{ Strings.Project_Name_Label }</th>
		<th>{ Strings.developer_name }</th>
		<th>{ Strings.no_of_properties }</th>
		<th>{ " " }</th>
	</tr>;
}

function RenderListItem( props: { project: PropertiesWithProject } ) {
	const { project } = props;
	return (
		<tr>
			<td data-label={ Strings.project_number }>{ getProjectNo( project ) }</td>
			<td data-label={ Strings.Project_Name_Label }>{ getProjectName( project ) }</td>
			<td data-label={ Strings.developer_name }>{ getDevName( project ) }</td>
			<td data-label={ Strings.no_of_properties }>{ getPropertyCount( project ) }</td>
			<td>
                <a href="#" className={"cur-hand underline"} data-item={ JSON.stringify( project ) }>
                    {Strings.view_details}
				</a>
			</td>
		</tr>
	);
}

export function getProjectName( project: PropertiesWithProject ) {
	const projectName = I8N.isRTL() ? project.ProjectNameAr : project.ProjectNameEn;
	if ( project.ProjectId != undefined && project.ProjectId !== 0 && project.ProjectNumber != undefined
		&& project.ProjectNumber !== 0 )
		return !isEmptyStringOrNull( projectName ) ? projectName! : "";
	return Strings.other_properties;
}

export function getProjectNo( project: PropertiesWithProject ) {
	return project.ProjectNumber ? "" + project.ProjectNumber : "-";
}

export function getDevName( project: PropertiesWithProject ) {
	const projectName = I8N.isRTL() ? project.DeveloperNameAr : project.DeveloperNameEn;
	return !isEmptyStringOrNull( projectName ) ? projectName! : "-";
}

export function getPropertyCount( project: PropertiesWithProject ) {
	return project.ProjectPropCount ? "" + project.ProjectPropCount : "";
}

export default ProjectListView;
